import React from 'react';
import Grid from 'material-ui/Grid';
import Hidden from 'material-ui/Hidden';
import GuidingParam from '../components/GuidingParam'; 
import pieChartImg2023 from '../assets/imgPieChart2023.png';
import fundingPDF2023 from '../assets/2023-PriorFundingInformation.pdf';
import ForeignFunding from "../components/ForeignFunding";


class Funding extends React.Component {

  render() {
    return (
    	<Grid container justify='center' alignItems='center' spacing={0}>
	    	<Grid item xs={12} className={'sectionText gradient white'}>
	        <Grid container justify='center' alignItems='stretch'>
	          <Grid item xs={12} md={10} align='left'>
	            <h1 className="white">Guiding Principles</h1>
	            <p className="white">
	            	The Foundation recognizes the importance of utilizing its assets to make a meaningful and substantial impact in selected philanthropic activities. To this end, the Foundation is particularly interested in:
	            </p>
	            <Grid container alignItems='stretch'>
		            <GuidingParam item={{title: 'Clarity', content: 'Focusing on problems/issues, and related charitable activities, which offer a clear strategy and solution, to an equally clear social problem.'}} />
		            <GuidingParam item={{title: 'Simplicity', content: 'Favoring projects that offer straightforward, problem-solving approaches with an effective and near term outcome or impact.'}} />
		            <GuidingParam item={{title: 'Effectiveness', content: 'Requiring a direct and concrete connection between the expenditure of funds and their immediate or near term effect. Special attention is given to low administrative/overhead cost candidate organizations and institutions.'}} />
		            <GuidingParam item={{title: 'Accountability', content: 'Emphasizing the funding of organizations, institutions, individuals and families directly responsible and accountable for the effective use of resources.'}} />
		            <GuidingParam item={{title: 'Necessity', content: 'The need for funding must be clearly evident and the funding sought cannot readily be obtained from other sources.'}} />
                <GuidingParam item={{title: 'Leverage', content: 'Seeking to provide "seed" or start-up resources in such a way as to result in substantially additional funding than that initially provided. This is accomplished by focusing on charitable organizations and institutions whose activities are self-sustaining, and themselves highly leveraged, by providing matching grants/funding, and other innovative approaches.'}} />
		          </Grid>
	          </Grid>
	        </Grid>
	      </Grid>
	      <Grid item xs={12} md={10} className='sectionText sectionText--top' align='left'>
	      	<Grid container alignItems='center' spacing={0}>
			      <Grid item xs={12}>
		          <h1>Primary Initiatives</h1>
              <ForeignFunding />
		          <p>
		          	In the context of these broad guiding principles, the Foundation's philanthropic funding incorporates a variety of approaches including:
		          </p>
		          <h2>Program Related Investments</h2>
		          Equity investments in and/or loans to charitable organizations and institutions, where the activity engaged in/operations promise a substantial likelihood that the funding will be used effectively for charitable purposes, as well as initiate or expand a self-sustaining activity or operation.
		        </Grid>
		        <Grid item xs={12} lg={8}>
		          <h2>Micro-Loans</h2>
		          <p>
		          	Primarily to individuals, families or groups of individuals in developing countries, particularly in Central and South America, and Africa, to develop business and employment opportunities for low income individuals and families.
		          </p>
		          <h2>Grants and Loans to Individuals</h2>
		          <p>
		          	Primarily in the fields of education, health and housing, to selected individuals and families who demonstrate a willingness and ability to improve themselves and the quality of their own lives.
		          </p>
		          <h2>Grants and Loans to Founder-Driven Charitable Enterprises</h2>
		          In specific fields, and at critical periods in their development, usually the start-up or earliest phase of a charitable organization's or institution's activities.
		        </Grid>
		        <Hidden mdDown>
		        	<Grid item lg={4}>
		        		<img src={pieChartImg2023} alt='Distribution of Initiatives' width='150%' />
		        	</Grid>
		        </Hidden>
		        <Grid item xs={12}>
		          <h2>Contributions</h2>
		          <p>
		          	Representing a relatively small proportion of the Foundation's total annual budget, such expenditures allow for the funding of charitable activities outside of the established criteria set forth above.
		          </p>
		        </Grid>
		      </Grid>
		    </Grid>
        <Grid item xs={12} md={10} className='sectionText teal' align='left'>
          <h2 className='green'>Organizations Currently Supporting</h2>
          <p>
            <ul>
              <li><a href='http://www.bostoncommunitycapital.org'>Boston Community Capital</a> &ndash; community
                support/development
              </li>
              <li><a href='http://www.liifund.org'>Low Income Housing Investment Fund (LIIF)</a> &ndash; affordable
                housing
              </li>
              <li><a href='http://www.ncclf.org'>Community Vision (formerly NCCLF)</a> &ndash; community
                support/development
              </li>
              <li><a href='http://www.craft3.org'>Craft3 (formerly Enterprise Cascadia)</a> &ndash; community
                support/development and microlending in the US
              </li>
              <li><a href='http://www.rcac.org'>Rural Community Assistance Corporation
                (RCAC)</a> &ndash; rural/farmworker community support/development
              </li>
              <li><a href='http://www.lihi.org'>Low Income Housing Institute (LIHI)</a> &ndash; affordable housing and
                homeless shelters in WA
              </li>
              <li><a href='http://www.clearinghousecdfi.com'>Clearinghouse</a> &ndash; microlending and community
                support/development
              </li>
              <li><a href='http://www.fclf.org'>Florida Community Loan Fund (FCLF)</a> &ndash; microlending and
                community support/development
              </li>
              <li><a href='http://www.sbhousingtrust.org'>Housing Trust Fund of Santa Barbara
                (HTFSB)</a> &ndash; affordable housing in SB County, CA
              </li>
              <li><a href='http://www.reachcdc.org'>REACH Community Development</a> &ndash; affordable housing and
                community support/development in OR
              </li>
              <li><a href='http://www.artspaceusa.org'>Artspace</a> &ndash; affordable real estate development for the
                arts in the US
              </li>
              <li><a href='http://www.cvhc.org'>Coachella Valley Housing Coalition (CVHC)</a> &ndash; rural/farmworker
                community support/development in CA
              </li>
              <li><a href='http://www.forgeonline.com'>FORGE (Financing Ozarks Rural
                Growth&Economy)</a> &ndash; rural/farmworker community support/development in AK
              </li>
              <li><a href='http://www.globalpartnerships.org'>Global Partnerships</a> &ndash; microlending in Central
                America
              </li>
              <li><a href='http://www.gchp.net'>Gulf Coast Housing Partnership</a> &ndash; affordable housing in LA</li>
              <li><a href='http://www.friendshipbridge.org'>Friendship Bridge</a> &ndash; microlending in Central
                America
              </li>
              <li><a href='http://www.homewise.org'>Homewise</a> &ndash; affordable housing and financial literacy in NM
              </li>
              <li><a href='http://www.loanfund.org'>New Mexico Community Development Loan Fund
                (NMCDLF)</a> &ndash; microlending and community support/development in NM
              </li>
              <li><a href='http://www.cafarmlink.org'>California Farm Link</a> &ndash; loan funding and technical
                assistance for small/underserved farmers
              </li>
              <li><a href='https://copo.org/'>Council of Peoples Organizations (COPO)</a> &ndash; community development
                south Asian population in NYC
              </li>
              <li><a href='https://thedof.org/'>Disability Opportunities Fund (DOF)</a> &ndash; supporting people with
                disabilities
              </li>
              <li><a href='https://accompanycapital.org'>Accompany Capital</a> &ndash; micro lending to female and
                immigrant entrepreneurs
              </li>
              <li><a href='https://www.crescentcare.org/'>NO/AIDS Task Force DBA CrescentCare</a> &ndash; community
                healthcare in New Orleans
              </li>
              <li><a href='https://www.peopleinc.net/'>People Incorporated Financial Services</a> &ndash; – community
                development rural Virginia
              </li>
              <li><a href='https://fswcf.org/'>First Southwest Community Fund</a> &ndash; microlending in rural SW
                Colorado
              </li>
            </ul>
          </p>
          <h2 className='green'>Organizations Previously Supported</h2>
          <p>
            <ul>
              <li><a href='https://www.accion.org/'>ACCION International</a> &ndash; strengthening the capacity of
                local, private institutions in Latin America
              </li>
              <li>Libraries for the Future &ndash; engaged in providing access to information through public libraries
                in NYC
              </li>
              <li><a href='https://sonomalandtrust.org/'>Sonoma Land Trust</a> &ndash; engaged in providing permanent
                protection of land in Sonoma County, CA
              </li>
              <li><a href='https://www.operawest.org/'>Opera West Foundation</a> &ndash; engaged in bringing
                Gilbert &amp; Sullivan musicals to San Francisco, CA elementary and middle schools
              </li>
              <li><a href='https://scccu.org/'>Santa Cruz Community Credit Union</a> &ndash; providing capital to
                support child-care providers, nonprofits, microenterprises, and affordable housing in Santa Cruz, CA
              </li>
              <li><a href='https://plymouthhousing.org/'>Plymouth Housing Group</a> &ndash; dedicated to eliminating
                homelessness and stabilizing homeless in Seattle, WA
              </li>
              <li><a href='https://impactcp.org/'>Impact Capital</a> &ndash; supporting affordable housing, community
                facilities and commercial real estate to anchor community revitalization projects in Seattle, WA
              </li>
              <li><a href='https://www.slochtf.org/'>Housing Trust Fund of San Luis Obispo County</a> &ndash; providing
                financial for affordable housing projects San Luis Obispo County, CA
              </li>
            </ul>
          </p>
          <h2 className='green'>Prior Funding History</h2>
          <p>
            <ul>
              <li><a href={fundingPDF2023} target='blank'>View our prior funding history</a></li>
            </ul>
          </p>
        </Grid>
      </Grid>
    );
  }
}

export default Funding;



// WEBPACK FOOTER //
// ./src/views/Funding.js